import React, { useMemo, useState } from "react";
import "../PayProPrivacy.css";

const privacy = [
  [`Introduction`, `PayPro Private Limited (“PayPro”, “we”, “us” or “our”) respects your privacy and is committed to protecting your personal information.

This Privacy Policy explains how we collect, use, process, store, protect and share personal information when you register for or use the PayPro consumer mobile application (“PayPro App”) and its related services.

Depending on the features available to you, the PayPro App may allow you to:

register and manage your account;

view and pay bills or invoices;

make digital payments;

use wallet or payment-related services;

transfer funds;

purchase mobile airtime, bundles or other services;

receive transaction and service notifications; and

access other payment services introduced from time to time.

Some services may be provided or supported by banks, financial institutions, Electronic Money Institutions (“EMIs”), Payment System Operators/Payment Service Providers (“PSOs/PSPs”), payment processors, merchants, billers or other authorised partners.

By registering for or using the PayPro App, you acknowledge that you have read and understood this Privacy Policy.`],
  [`Information We Collect`, `The information PayPro collects depends on the services and features you use.

Account and Personal Information

We may collect:

full name;

mobile number;

email address;

address, where required;

date of birth, where required;

profile information;

account or consumer number; and

other information required to create or maintain your account.

Identity and Verification Information

Where identity verification, KYC or regulatory checks are required, we may process:

CNIC or other permitted identification information;

identity-document images;

date of birth;

photographs or selfies;

verification status and results; and

other information required for regulatory, fraud-prevention or security purposes.

Payment and Transaction Information

When you make or attempt a payment or financial transaction, we may process:

transaction amount, date and time;

transaction reference and status;

bill or invoice information;

merchant or biller information;

bank account, IBAN, wallet or beneficiary information, where applicable;

payment method;

refund, reversal or dispute information; and

other information required to process and reconcile your transaction.

Where card payments are processed through authorised banks, payment gateways or processors, card information may be processed directly by those providers.

PayPro will only process payment information necessary to provide the relevant service.

Device and Technical Information

We may automatically collect technical information such as:

device model and operating system;

App version;

IP address;

device or application identifiers;

login and session information;

crash reports and error logs;

network information; and

security-related information.

This information may be used to operate, secure, troubleshoot and improve the App.

Customer Support Information

When you contact PayPro, we may collect information relating to your enquiry or complaint, including messages, transaction references, screenshots or documents provided by you.`],
  [`Information Received From Third Parties`, `PayPro may receive information from organisations involved in providing the service you use, including:

merchants and billers;

schools and educational institutions;

banks and financial institutions;

EMIs and PSOs/PSPs;

payment gateways and processors;

1LINK, 1BILL or other payment infrastructure providers;

wallet providers;

telecommunication companies;

identity-verification providers; and

fraud-prevention or security providers.

For example, a biller may provide your consumer number, invoice number, payment amount or due date so that your bill can be displayed and paid through the App.

We will use such information only for legitimate business, payment, security or regulatory purposes.`],
  [`Mobile Device Permissions`, `The PayPro App may request access to certain device functions only where required for a particular feature.

Camera

Camera access may be used to:

scan QR codes;

capture identification documents;

take photographs for verification; or

upload information required for a service.

Photos and Files

You may be asked to select photographs or documents where uploading a file is required.

Where possible, PayPro may use your device’s built-in file or photo selector instead of requesting broad storage access.

Contacts

If the App allows you to select a beneficiary or recipient from your contacts, contact access may be requested.

PayPro will not use your contacts for unrelated marketing without appropriate notice or consent.

SMS and OTP

PayPro may use supported OTP retrieval or verification technologies to simplify mobile-number verification.

Where possible, PayPro will use methods that retrieve the required verification code without accessing unrelated SMS messages.

Location

Location may be requested where reasonably required for security, fraud prevention, regulatory requirements or a location-based service.

Notifications

The App may send notifications relating to:

transactions;

account activity;

security;

bill reminders;

service updates; and

promotions, where permitted.

You may manage optional permissions and notifications through your device settings.

Biometrics

Where biometric login is available, fingerprint or facial recognition is generally processed by your device’s operating system.

PayPro does not need to receive or store your fingerprint or facial biometric template merely because you use your device’s biometric authentication.`],
  [`How We Use Your Information`, `PayPro may use personal information to:

Provide and Manage Your Account

register and maintain your account;

verify your identity or mobile number;

authenticate your login; and

provide account-related services.

Process Payments and Services

display and pay bills or invoices;

process payments and transfers;

provide transaction status and history;

process refunds or reversals; and

provide other services requested through the App.

Meet Regulatory Requirements

Where applicable, information may be processed for:

KYC and customer verification;

fraud prevention;

transaction monitoring;

anti-money-laundering requirements;

regulatory reporting; and

other legal obligations.

Protect You and PayPro

We may use information to:

detect suspicious activity;

prevent fraud;

protect customer accounts;

prevent unauthorised access; and

investigate security incidents.

Improve Our Services

We may use App usage, crash and performance information to improve:

reliability;

security;

user experience;

functionality; and

future products and services.

Communicate With You

We may send:

transaction confirmations;

account and security alerts;

service notices;

customer-support responses;

policy or terms updates; and

promotional communications where permitted.`],
  [`How We Share Your Information`, `PayPro does not sell personal information.

We may share information only where reasonably necessary to provide a service, meet legal or regulatory requirements, protect customers or operate our business.

Information may be shared with:

Financial and Payment Partners

Including:

banks;

EMIs;

PSOs/PSPs;

payment processors;

payment gateways;

card networks;

wallet providers; and

payment infrastructure providers.

Merchants and Billers

When you make a payment, we may provide the relevant merchant or biller with information needed to identify and reconcile the payment, such as:

consumer or invoice number;

transaction reference;

amount;

payment date; and

payment status.

We do not share your PIN, password or OTP with merchants or billers.

Technology and Service Providers

We may use authorised service providers for:

hosting;

communications;

cybersecurity;

application analytics;

crash reporting;

customer support; and

other technical or operational services.

Government and Regulatory Authorities

Information may be disclosed where required or permitted by applicable law, regulation, court order or lawful governmental or regulatory request.

At Your Direction

Information may also be shared when you instruct or authorise us to complete a transaction or provide a particular service.`],
  [`Partner Financial Services`, `Certain services available through the PayPro App may be provided or supported by a third-party financial institution or regulated service provider.

In such cases:

information may be shared with that provider;

additional KYC or verification may be required;

the provider may have independent regulatory obligations;

transaction records may be maintained by both PayPro and the provider; and

the provider’s terms and privacy policy may also apply.

Where relevant, PayPro will identify the partner responsible for providing the particular service.`],
  [`Data Security`, `PayPro uses reasonable administrative, organisational and technical safeguards designed to protect personal information from unauthorised access, loss, misuse, alteration or disclosure.

Security measures may include:

encryption;

secure authentication;

access controls;

security monitoring;

fraud-detection mechanisms;

secure software-development practices;

network and infrastructure security; and

restricted employee and service-provider access.

Customers are also responsible for keeping their account secure.

You should:

never share your OTP, password or PIN;

use a secure device lock;

keep the PayPro App updated;

avoid using compromised or modified devices; and

immediately report suspicious activity to PayPro.

No digital platform can guarantee absolute security, but PayPro continually works to maintain safeguards appropriate to the sensitivity of the information processed.`],
  [`Data Retention`, `PayPro retains personal information only for as long as necessary for the purpose for which it was collected or where retention is required for legal, regulatory, financial, security or operational reasons.

This may include retention of:

account records;

transaction history;

identity and KYC records;

complaint and support records;

security logs; and

financial or regulatory records.

Certain transaction or compliance information may therefore need to be retained even after your PayPro account has been closed or deleted.

When information is no longer required, PayPro will take reasonable steps to delete, anonymise or securely dispose of it.`],
  [`Account and Data Deletion`, `You may request closure and deletion of your PayPro consumer account.

PayPro may provide account-deletion options:

within the PayPro App;

through the PayPro website; or

through PayPro customer support.

After a valid deletion request, PayPro will delete or anonymise information associated with your account unless specific information must be retained for purposes such as:

legal or regulatory compliance;

transaction records;

KYC or AML requirements;

fraud prevention;

cybersecurity;

dispute resolution; or

legal claims.

Account deletion is different from temporary account suspension or deactivation.

If a financial product or wallet is separately maintained by a partner institution, deleting your PayPro App account may not automatically close that separate financial product.`],
  [`Your Privacy Choices and Rights`, `Subject to applicable requirements and identity verification, you may request to:

access personal information maintained about you;

correct inaccurate information;

update your profile;

withdraw consent where processing depends on consent;

disable optional device permissions;

opt out of optional promotional communications;

close your account;

request deletion of information PayPro is not required to retain; or

raise a privacy-related complaint.

Some requests may be limited where PayPro is required to retain or process information for regulatory, security, financial-record or fraud-prevention purposes.`],
  [`Marketing Communications`, `Where permitted, PayPro may send information about products, features, campaigns, promotions or offers through channels such as:

push notifications;

SMS;

email;

WhatsApp; or

in-App messages.

Where required, appropriate consent will be obtained.

You may opt out of optional marketing communications.

However, you may still receive essential communications such as:

OTPs;

transaction alerts;

security notices;

regulatory notices;

account notifications; and

service updates.`],
  [`Fraud Awareness`, `PayPro will never legitimately ask you to share your OTP, PIN or password through an unsolicited telephone call, email, SMS, WhatsApp message or social-media communication.

If you receive a suspicious communication:

do not share confidential account information;

do not approve an unfamiliar transaction;

do not install unknown applications;

do not provide remote access to your device; and

contact PayPro through an official support channel.`],
  [`Third-Party Services`, `The PayPro App may contain links to websites, applications or services operated independently by third parties.

Their privacy practices may differ from PayPro’s.

Where you use a separately operated third-party service, you should review that provider’s privacy policy and applicable terms.`],
  [`Children and Minors`, `The PayPro App is intended for persons who meet the eligibility requirements applicable to the relevant service.

Some payment or financial services may require a minimum age, CNIC, KYC or other eligibility requirements.

Where a service is available to or on behalf of a minor, additional consent, guardian involvement or verification may be required.`],
  [`Changes to This Privacy Policy`, `PayPro may update this Privacy Policy to reflect:

new App features;

changes in services;

new financial or technology partners;

security developments;

regulatory requirements; or

changes in how information is processed.

The “Last Updated” date will be revised whenever the policy changes.

Where a change is material, PayPro may notify you through the App or another appropriate communication channel.

Where renewed consent is legally required, PayPro will request it before the relevant processing takes place.`],
  [`Consumer Terms & Conditions`, `This Privacy Policy explains how PayPro handles your personal information.

Your use of the PayPro App is also subject to the PayPro Consumer App Terms & Conditions and any additional terms applicable to specific financial services.

Where a service is provided by a third-party financial institution, that provider’s applicable terms and privacy policy may also apply.`],
  [`Contact Us`, `If you have questions, complaints or requests concerning this Privacy Policy or your personal information, you may contact:

PayPro Private Limited

Email: info@paypro.com.pk
Phone: +92 309 0729776
Address: Suite 302, Plot 1C, Tariq Center, Tariq Road, Karachi, Pakistan

You may also contact PayPro through the customer-support options available within the App or through PayPro’s official website.

PayPro may ask you to verify your identity before processing requests involving your personal or account information.`],
  [`Acknowledgement`, `By registering for or using the PayPro App, you acknowledge that you have been provided access to this Privacy Policy and understand how PayPro processes your personal information.

Where specific consent is required for a feature, device permission or processing activity, PayPro will request such consent separately through an appropriate affirmative action.

PayPro Private Limited
Consumer Mobile Application Privacy Policy
Version 1.0`]
];

const slug = (text) => text.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export default function PrivacyPolicy() {
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return privacy;
    return privacy.filter(([title, body]) =>
      `${title} ${body}`.toLowerCase().includes(q)
    );
  }, [query]);

  return (
    <div className="page">
     

      <section className="hero">
        <div className="eyebrow">PAYPRO CONSUMER APP</div>
        <h1>Privacy Policy<br /><strong>for Consumers</strong></h1>
        <p>Learn how PayPro collects, uses, protects, stores and shares personal information when you use the PayPro consumer mobile application.</p>
      </section>

      <div className="layout">
        <aside className="sidebar">
          <div className="sidebar-title">Privacy Policy</div>
          <nav>
            {privacy.map(([sectionTitle], i) => (
              <a className="link" href={`#${slug(sectionTitle)}`} key={sectionTitle}>
                <span>{String(i + 1).padStart(2, "0")}</span>
                <span>{sectionTitle}</span>
              </a>
            ))}
          </nav>
        </aside>

        <main>
          <div className="search">
            <span className="search-icon">⌕</span>
            <input
              value={query}
              onChange={e => setQuery(e.target.value)}
              placeholder="Search this document..."
            />
            {query && <button onClick={() => setQuery("")}>×</button>}
          </div>

          {filtered.map(([sectionTitle, body]) => (
            <section className="section" id={slug(sectionTitle)} key={sectionTitle}>
              <div className="number">
                {String(privacy.findIndex(s => s[0] === sectionTitle) + 1).padStart(2, "0")}
              </div>
              <div>
                <h2>{sectionTitle}</h2>
                {body.split("\n\n").map((paragraph, i) => (
                  <div className="paragraph" key={i}>
                    {paragraph.split("\n").map((line, j) =>
                      line.startsWith("•") ? (
                        <div className="bullet" key={j}>
                          <b>•</b><span>{line.slice(1).trim()}</span>
                        </div>
                      ) : <div key={j}>{line}</div>
                    )}
                  </div>
                ))}
              </div>
            </section>
          ))}

          {filtered.length === 0 && <div className="empty">No matching content found.</div>}

          <footer className="footer">
            <strong>PayPro Private Limited</strong>
            <span>Version 1.0</span>
            <span>Last Updated: {new Date().toLocaleDateString()}</span>

          </footer>
        </main>
      </div>
    </div>
  );
}
